// extracted by mini-css-extract-plugin
export var btn = "G_mB z_vl z_t4 d_bz d_bP d_bD d_dw";
export var full = "G_wt d_w d_H";
export var hoverStyle = "G_mF";
export var zoom = "G_mG";